export default __webpack_public_path__ + "static/media/Girdle of the Furious Swipe.2c9008e2.jpg";